export const joinTruthy = (values: any[], separator: string): string =>
  values.filter(Boolean).join(separator);
